import { parse, Kind, getNamedType } from 'graphql';
export function parseSelectionSet(selectionSet) {
    const query = parse(selectionSet).definitions[0];
    return query.selectionSet;
}
export function typesContainSelectionSet(types, selectionSet) {
    const fieldMaps = types.map(type => type.getFields());
    for (const selection of selectionSet.selections) {
        if (selection.kind === Kind.FIELD) {
            const fields = fieldMaps.map(fieldMap => fieldMap[selection.name.value]).filter(field => field != null);
            if (!fields.length) {
                return false;
            }
            if (selection.selectionSet != null) {
                return typesContainSelectionSet(fields.map(field => getNamedType(field.type)), selection.selectionSet);
            }
        }
        else if (selection.kind === Kind.INLINE_FRAGMENT && selection.typeCondition.name.value === types[0].name) {
            return typesContainSelectionSet(types, selection.selectionSet);
        }
    }
    return true;
}
export function typeContainsSelectionSet(type, selectionSet) {
    const fields = type.getFields();
    for (const selection of selectionSet.selections) {
        if (selection.kind === Kind.FIELD) {
            const field = fields[selection.name.value];
            if (field == null) {
                return false;
            }
            if (selection.selectionSet != null) {
                return typeContainsSelectionSet(getNamedType(field.type), selection.selectionSet);
            }
        }
        else if (selection.kind === Kind.INLINE_FRAGMENT && selection.typeCondition.name.value === type.name) {
            return typeContainsSelectionSet(type, selection.selectionSet);
        }
    }
    return true;
}
//# sourceMappingURL=selectionSets.js.map